module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/how-babies-are-delivered/"},"excerpt":"You may have heard that storks deliver babies. For some reason, the only photographs of storks in existence are always when they have an…","timeToRead":1,"frontmatter":{"title":"How Babies Are Delivered","tags":["babies","biology","birds"]}}}]}},"pathContext":{"tag":"babies"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-babies.json
// module id = 749
// module chunks = 51809211136982